module.exports = __webpack_public_path__ + "static/img/coner3.8edabc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/coner3.png
// module id = mGgN
// module chunks = 1